import React, {Component} from 'react';
import {BrowserRouter as Router, Route, Link} from 'react-router-dom';
import {
  Table,
  Card,
  Row,
  Col,
  Form,
  Image,
  Button,
  Tab,
  Tabs,
} from 'react-bootstrap';
import './MyProfile.css';
import {appConfig} from '../../config';
var dateFormat = require('dateformat');

class MyProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DistributorprofDtls: '',
    };
  }

  convertTime = timefetched => {
    // console.log(timefetched);
    let hours = Math.floor(timefetched / 60);
    // console.log(hours);
    let AmOrPm = hours >= 12 ? 'pm' : 'am';
    let minutes = timefetched - hours * 60;
    minutes = minutes > 10 ? minutes : '0' + minutes;
    let finalTime;
    return (finalTime =
      hours > 12
        ? hours - 12 + ':' + minutes + ' ' + AmOrPm
        : hours + ':' + minutes + ' ' + AmOrPm);
  };

  componentDidMount() {
    this.props.fetchDistributorProfile();
  }

  // handleEditDistributorprof = () => {
  //   console.log("**********************************", item);
  //   this.setState({
  //     DistributorprofDtls: item
  //   });
  // };

  render() {
    const item = this.props.DistributorprofDtls
      ? this.props.DistributorprofDtls
      : null;
    return (
      <div className="salesreturndiv">
        <Row>
          <Col xs={12} sm={12} md={1} lg={1} />
          <Col xs={12} sm={12} md={10} lg={10}>
            <Card>
              <div className="editprofclose">
                <Link to="/dashboard" onClick={() => window.scrollTo(0, 0)}>
                  <i className="fa fa-times fa-lg closeiconview " />
                </Link>
              </div>
              <Tabs onSelect={k => this.setState({...this.state, key: k})}>
                <Tab eventKey="new" title="Basic Details">
                  <div className="tabprofsdiv">
                    <div className="profileimg">
                      <Card.Body>
                        <Row>
                          <Col xs={12} sm={12} md={9} lg={9}>
                            <Row>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  Organization Name
                                </p>
                                <p className="profilebasicdetailscontper">
                                  {' '}{item !== null && item.name}
                                </p>
                              </Col>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  Name
                                </p>
                                <p className="profilebasicdetailscontper">
                                  {' '}{item !== null && item.contactPersn}
                                </p>
                              </Col>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  Contact Number
                                </p>
                                <p className="profilebasicdetailscontper">
                                  {item !== null && item.mobile}
                                </p>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  Email
                                </p>
                                <p className="profilebasicdetailswmails">
                                  {item !== null && item.email}
                                </p>
                              </Col>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  Address
                                </p>
                                <p className="profilebasicdetailscontper">
                                  {item !== null && item.addr2}
                                </p>
                              </Col>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  City
                                </p>
                                <p className="profilebasicdetailscontper">
                                  {' '}{item !== null && item.city}
                                </p>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  Pin Code
                                </p>
                                <p className="profilebasicdetailscontper">
                                  {' '}{item !== null && item.zip}
                                </p>
                              </Col>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  State
                                </p>
                                <p className="profilebasicdetailscontper">
                                  {item !== null &&
                                    item.state &&
                                    item.state.name}
                                </p>
                              </Col>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  District
                                </p>
                                <p className="profilebasicdetailscontper">
                                  {item !== null &&
                                    item.district &&
                                    item.district.name}
                                </p>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  Landmark
                                </p>
                                <p className="profilebasicdetailscontper">
                                  {item !== null && item.landmark}
                                </p>
                              </Col>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  Website
                                </p>
                                <p className="profilebasicdetailswmails">
                                  {item !== null && item.website}
                                </p>
                              </Col>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  GST Number
                                </p>
                                <p className="profilebasicdetailscontper">
                                  {' '}{item !== null && item.gstin}
                                </p>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  Drug License(20B)
                                </p>
                                <p className="profilebasicdetailscontper">
                                  {item !== null && item.licenceNo}
                                </p>
                              </Col>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  Drug License(21B)
                                </p>
                                <p className="profilebasicdetailscontper">
                                  {item !== null && item.drugLicense}
                                </p>
                              </Col>
                              <Col xs={12} sm={12} md={4} lg={4}>
                                <p className="profilebasicdetailscontname">
                                  Credit Period
                                </p>
                                <p className="profilebasicdetailscontper">
                                  {item !== null && item.crdtPeriod}
                                </p>
                              </Col>
                            </Row>
                          </Col>

                          <Col xs={12} sm={12} md={3} lg={3}>
                            <div style={{display: 'grid'}}>
                              <Form.Label />
                              <img
                                className="viewprfimage"
                                src={[
                                  item && item.imgUrl !== undefined
                                    ? appConfig.imgServerip +
                                      '/get?imgName=' +
                                      item.imgUrl
                                    : require('../../../src/assets/img/userImg.png'),
                                ]}
                              />
                            </div>
                            <div>
                              <h3 className="profilename">
                                {item !== null && item.name}
                              </h3>
                            </div>
                            <div>
                              <h5 className="profilenum">
                                {item !== null &&
                                  item.userId &&
                                  item.userId.mobileNo}
                              </h5>
                            </div>
                            <div>
                              <Link
                                to="/editprofile"
                                onClick={() => window.scrollTo(0, 0)}
                              >
                                <i className="fa fa-edit fa-lg editiconprof" />
                                {/* // style={{
                                //   marginLeft: -75,
                                //   color: "black"
                                // }} */}
                              </Link>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </div>
                  </div>
                </Tab>

                <Tab eventKey="processing" title="Bank Details">
                  <div className="tabprofsdiv">
                    <div className="profileimg">
                      <Card.Body>
                        <Row>
                          <Col xs={12} sm={12} md={3} lg={3}>
                            <p className="profilebasicdetailscontname">
                              Account No
                            </p>
                            <p className="profilebasicdetailscontper">
                              {' '}{item !== null && item.acntNo}
                            </p>
                          </Col>
                          <Col xs={12} sm={12} md={3} lg={3}>
                            <p className="profilebasicdetailscontname">
                              Account Holder
                            </p>
                            <p className="profilebasicdetailscontper">
                              {' '}{item !== null && item.acntName}
                            </p>
                          </Col>
                          <Col xs={12} sm={12} md={3} lg={3}>
                            <p className="profilebasicdetailscontname">
                              Account Type
                            </p>
                            <p className="profilebasicdetailscontper">
                              {' '}{item !== null && item.acntType}
                            </p>
                          </Col>
                          <Col xs={12} sm={12} md={3} lg={3}>
                            <p className="profilebasicdetailscontname">
                              Bank Name
                            </p>
                            <p className="profilebasicdetailscontper">
                              {' '}{item !== null &&
                                item.bankName &&
                                item.bankName.name}
                            </p>
                          </Col>
                        </Row>

                        <Row>
                          {/* <Col xs={12} sm={12} md={4} lg={4}>
                            <p className="profilebasicdetailscontname">
                              Bank Name
                            </p>
                            <p className="profilebasicdetailscontper">
                              {" "}
                              {item !== null &&
                                item.bankName &&
                                item.bankName.name}
                            </p>
                          </Col> */}
                          <Col xs={12} sm={12} md={3} lg={3}>
                            <p className="profilebasicdetailscontname">IFSC</p>
                            <p className="profilebasicdetailscontper">
                              {' '}{item !== null && item.ifscCode}
                            </p>
                          </Col>
                          <Col xs={12} sm={12} md={3} lg={3}>
                            <p className="profilebasicdetailscontname">
                              Branch Name
                            </p>
                            <p className="profilebasicdetailscontper">
                              {' '}{item !== null && item.brchName}
                            </p>
                          </Col>
                          <Col xs={12} sm={12} md={3} lg={3}>
                            <p className="profilebasicdetailscontname">
                              Branch Address
                            </p>
                            <p className="profilebasicdetailscontper">
                              {' '}{item !== null && item.brchAddr}
                            </p>
                          </Col>
                        </Row>

                        {/* <Row>
                        <Col xs={12} sm={12} md={3} lg={3}>
                            <p className="profilebasicdetailscontname">
                              Branch Address
                            </p>
                            <p className="profilebasicdetailscontper">
                              {" "}
                              {item !== null && item.brchAddr}
                            </p>
                          </Col>
                        </Row> */}
                      </Card.Body>
                    </div>{' '}
                  </div>
                </Tab>

                <Tab eventKey="workingHours" title="Working Hours">
                  <div className="tabprofsdiv">
                    <div className="profileimg">
                      <Card.Body>
                        <Row>
                          <Col xs={12} sm={12} md={6} lg={6}>
                            {/* <p className=""> */}

                            <Row>
                              <Col xs={12} sm={12} md={3} lg={3}>
                                <p className="daysdiv">Monday</p>
                              </Col>
                              <Col xs={12} sm={12} md={7} lg={7}>
                                {item !== null &&
                                item.workingHrs &&
                                item.workingHrs.mon.open
                                  ? this.convertTime(item.workingHrs.mon.open) +
                                    ' to ' +
                                    this.convertTime(item.workingHrs.mon.close)
                                  : 'Holiday'}
                              </Col>
                            </Row>
                            {/* <p>
                              Mon &nbsp;
                              {item !== null &&
                              item.workingHrs &&
                              item.workingHrs.mon.open
                                ? this.convertTime(item.workingHrs.mon.open) +
                                  ' to ' +
                                  this.convertTime(item.workingHrs.mon.close)
                                : 'Holiday'}
                            </p> */}
                            {/* <p>
                              Tue &nbsp;
                              {item !== null &&
                              item.workingHrs &&
                              item.workingHrs.tue.open
                                ? this.convertTime(item.workingHrs.tue.open) +
                                  ' to ' +
                                  this.convertTime(item.workingHrs.tue.close)
                                : 'Holiday'}
                            </p> */}

                            <Row>
                              <Col xs={12} sm={12} md={3} lg={3}>
                                <p className="daysdiv">Tuesday</p>
                              </Col>
                              <Col xs={12} sm={12} md={7} lg={7}>
                                {item !== null &&
                                item.workingHrs &&
                                item.workingHrs.tue.open
                                  ? this.convertTime(item.workingHrs.tue.open) +
                                    ' to ' +
                                    this.convertTime(item.workingHrs.tue.close)
                                  : 'Holiday'}
                              </Col>
                            </Row>

                            {/* <p>
                              Wed &nbsp;
                              {item !== null &&
                              item.workingHrs &&
                              item.workingHrs.wed.open
                                ? this.convertTime(item.workingHrs.wed.open) +
                                  ' to ' +
                                  this.convertTime(item.workingHrs.wed.close)
                                : 'Holiday'}
                            </p> */}

                            <Row>
                              <Col xs={12} sm={12} md={3} lg={3}>
                                <p className="daysdiv">Wednesday</p>
                              </Col>
                              <Col xs={12} sm={12} md={7} lg={7}>
                                {item !== null &&
                                item.workingHrs &&
                                item.workingHrs.wed.open
                                  ? this.convertTime(item.workingHrs.wed.open) +
                                    ' to ' +
                                    this.convertTime(item.workingHrs.wed.close)
                                  : 'Holiday'}
                              </Col>
                            </Row>

                            {/* <p>
                              Thu &nbsp;
                              {item !== null &&
                              item.workingHrs &&
                              item.workingHrs.thu.open
                                ? this.convertTime(item.workingHrs.thu.open) +
                                  ' to ' +
                                  this.convertTime(item.workingHrs.thu.close)
                                : 'Holiday'}
                            </p> */}

                            <Row>
                              <Col xs={12} sm={12} md={3} lg={3}>
                                <p className="daysdiv">Thursday</p>
                              </Col>
                              <Col xs={12} sm={12} md={7} lg={7}>
                                {item !== null &&
                                item.workingHrs &&
                                item.workingHrs.thu.open
                                  ? this.convertTime(item.workingHrs.thu.open) +
                                    ' to ' +
                                    this.convertTime(item.workingHrs.thu.close)
                                  : 'Holiday'}
                              </Col>
                            </Row>

                            {/* <p>
                              Fri &nbsp;
                              {item !== null &&
                              item.workingHrs &&
                              item.workingHrs.fri.open
                                ? this.convertTime(item.workingHrs.fri.open) +
                                  ' to ' +
                                  this.convertTime(item.workingHrs.fri.close)
                                : 'Holiday'}
                            </p> */}

                            <Row>
                              <Col xs={12} sm={12} md={3} lg={3}>
                                <p className="daysdiv">Friday</p>
                              </Col>
                              <Col xs={12} sm={12} md={7} lg={7}>
                                {item !== null &&
                                item.workingHrs &&
                                item.workingHrs.fri.open
                                  ? this.convertTime(item.workingHrs.fri.open) +
                                    ' to ' +
                                    this.convertTime(item.workingHrs.fri.close)
                                  : 'Holiday'}
                              </Col>
                            </Row>

                            {/* <p>
                              Sat &nbsp;
                              {item !== null &&
                              item.workingHrs &&
                              item.workingHrs.sat.open
                                ? this.convertTime(item.workingHrs.sat.open) +
                                  ' to ' +
                                  this.convertTime(item.workingHrs.sat.close)
                                : 'Holiday'}
                            </p> */}

                            <Row>
                              <Col xs={12} sm={12} md={3} lg={3}>
                                <p className="daysdiv">Saturday</p>
                              </Col>
                              <Col xs={12} sm={12} md={7} lg={7}>
                                {item !== null &&
                                item.workingHrs &&
                                item.workingHrs.sat.open
                                  ? this.convertTime(item.workingHrs.sat.open) +
                                    ' to ' +
                                    this.convertTime(item.workingHrs.sat.close)
                                  : 'Holiday'}
                              </Col>
                            </Row>

                            {/* <p>
                              Sun &nbsp;
                              {item !== null &&
                              item.workingHrs &&
                              item.workingHrs.sun.open
                                ? this.convertTime(item.workingHrs.sun.open) +
                                  ' to ' +
                                  this.convertTime(item.workingHrs.sun.close)
                                : 'Holiday'}
                            </p> */}

                            <Row>
                              <Col xs={12} sm={12} md={3} lg={3}>
                                <p className="daysdiv">Sunday</p>
                              </Col>
                              <Col xs={12} sm={12} md={7} lg={7}>
                                {item !== null &&
                                item.workingHrs &&
                                item.workingHrs.sun.open
                                  ? this.convertTime(item.workingHrs.sun.open) +
                                    ' to ' +
                                    this.convertTime(item.workingHrs.sun.close)
                                  : 'Holiday'}
                              </Col>
                            </Row>

                            {/* </p> */}
                          </Col>
                        </Row>
                      </Card.Body>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={1} lg={1} />
        </Row>
      </div>
    );
  }
}
export default MyProfile;
